module.exports = __webpack_public_path__ + "static/media/qr.42ff225f.png";